import { render, staticRenderFns } from "./reco-player.vue?vue&type=template&id=25485ea4&scoped=true&"
import script from "./reco-player.vue?vue&type=script&lang=ts&"
export * from "./reco-player.vue?vue&type=script&lang=ts&"
import style0 from "./reco-player.vue?vue&type=style&index=0&id=25485ea4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25485ea4",
  null
  
)

export default component.exports